<div class="container">
  <div class="title">{{title}}
    <nz-tag [nzColor]="'#1062B9'" *ngIf="titleTag != ''">{{titleTag}}</nz-tag>
  </div>
  <div class="divider" style="margin: 8px 0 8px 0;"></div>
  @if(!detailsData){
    <app-no-data></app-no-data>
  } @else {
    @for (column of detailsMeta.columns; track $index) {
      @if (shouldShowColumn(column)) {
        <div class="item">
          <div class="item-label">{{ column.displayName }}</div>
          <div class="item-value">
            <app-tos-table-td
              [value]="CommonUtils.getNestedValue(detailsData, column.fieldName)"
              [rowData]="detailsData[column.fieldName]"
              [column]="column"
              (inlineAction)="handleInlineAction($event)"
            ></app-tos-table-td>
          </div>
        </div>
      }
    }
  }
</div>
